import React from "react";
import { motion } from "framer-motion";
import { ReactComponent as Wichtel } from "../assets/wichtel.svg";
import SnowfallEffect from "../components/SnowfallEffect";
import LanguageToggle from "../components/LanguageToggle";
import ProfileEdit from "@/components/ProfileEdit";
import ThemeToggle from "../components/ThemeToggle";
import useThemeStore from "../store/themeStore";
import GroupsList from "./GroupsList";
import Welcome from "./Welcome";
import useAuthStore from "@/store/authStore";

const Home = () => {
  const { isAuthenticated } = useAuthStore();
  const { theme } = useThemeStore();

  return (
    <div
      className={`min-h-screen ${
        theme === "dark"
          ? "bg-gray-900"
          : "bg-gradient-to-br from-red-50 via-pink-50 to-blue-50"
      }`}
    >
      <SnowfallEffect />
      <motion.header
        className="container mx-auto px-4 py-6"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Wichtel className="h-12 w-12" />
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
              Jingolin
            </h1>
          </div>
          <div className="flex items-center gap-2">
            <LanguageToggle />
            <ThemeToggle />
            {isAuthenticated && <ProfileEdit />}
          </div>
        </div>
      </motion.header>

      <div>{isAuthenticated ? <GroupsList /> : <Welcome />}</div>
    </div>
  );
};

export default Home;
